import * as React from 'react';
import { Button } from 'components';
import { FilterList } from '@mui/icons-material';
import { TProductsFiltersButton } from './ProductsFiltersButton.types';
import { getSelectedProductFiltersCount } from 'utils/product';
import './ProductsFiltersButton.styled.scss';

export const ProductsFiltersButton: TProductsFiltersButton = ({
  onClick,
  selectedFilters,
  filters,
}) => {
  const selectedFiltersCount = React.useMemo(
    () => getSelectedProductFiltersCount(selectedFilters, filters),
    [selectedFilters, filters]
  );

  return (
    <Button
      variant="outlined"
      startIcon={<FilterList />}
      onClick={onClick}
      className="products-filters-button"
    >
      Фільтри
      {selectedFiltersCount > 0 && (
        <span className="products-filters-button__count">
          {selectedFiltersCount}
        </span>
      )}
    </Button>
  );
};
